
interface IndustrySectionProps {
  title: string;
  description: string;
  capabilities: string[];
  icon: string;
  reverse: boolean;
  image: string;
}

const IndustrySection = ({ title, description, capabilities, icon, reverse, image }: IndustrySectionProps) => {
  return (
    <section className={`py-24 ${reverse ? 'bg-zinc-950' : 'bg-black'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-16 items-center`}>
          <div className={`${reverse ? 'lg:order-2' : 'lg:order-1'}`}>
            <div className="w-14 h-14 flex items-center justify-center bg-emerald-500/10 rounded-xl mb-6">
              <i className={`${icon} text-emerald-400 text-2xl`}></i>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              {title}
            </h2>
            
            <p className="text-lg text-gray-300 leading-relaxed mb-10 max-w-xl">
              {description}
            </p>

            <div className="mb-4">
              <span className="text-emerald-400 text-sm font-semibold uppercase tracking-wider">
                Key Capabilities
              </span>
            </div>

            <div className="space-y-4">
              {capabilities.map((capability, index) => (
                <div key={index} className="flex items-center gap-4 bg-zinc-900/50 border border-zinc-800 rounded-lg px-5 py-4 hover:border-emerald-500/30 transition-colors">
                  <div className="w-8 h-8 flex items-center justify-center bg-emerald-500/10 rounded-lg">
                    <i className="ri-check-line text-emerald-400 text-lg"></i>
                  </div>
                  <p className="text-white text-base">{capability}</p>
                </div>
              ))}
            </div>
          </div>

          <div className={`${reverse ? 'lg:order-1' : 'lg:order-2'}`}>
            <div className="relative rounded-2xl overflow-hidden border border-zinc-800 group">
              <img
                src={image}
                alt={title}
                className="w-full h-96 object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustrySection;
